module.exports = __webpack_public_path__ + "static/media/family.604b8f53.png";